import { render, staticRenderFns } from "./scholarStatus.vue?vue&type=template&id=073f5473&scoped=true"
import script from "./scholarStatus.vue?vue&type=script&lang=js"
export * from "./scholarStatus.vue?vue&type=script&lang=js"
import style0 from "./scholarStatus.vue?vue&type=style&index=0&id=073f5473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f5473",
  null
  
)

export default component.exports